// extracted by mini-css-extract-plugin
module.exports = {"viewport":"styles_viewport__nDWz_","container":"styles_container__5hGS0","slide":"styles_slide__AH_em"};